import React, { useCallback } from "react";

import * as firebase from "firebase/app";
import "firebase/firestore";

import { useDocumentData } from "react-firebase-hooks/firestore";
import { Dropdown } from "react-bootstrap";

const IdPlayer = (props) => {
  const [contact_info] = useDocumentData(
    firebase.firestore().doc(`contacts/${props.idInfo.contact_id}`)
  );

  const deleteIdPlayer = useCallback(() => {
    let player_ids = props.player_ids;
    let i = 0;

    player_ids.forEach((el) => {
      if (el === props.idInfo) {
        player_ids.splice(i, 1);
        console.log(player_ids);

        firebase.firestore().doc(`users/${props.userId}`).update({
          player_ids: player_ids,
        });
      }
      i++;
    });

    firebase.firestore().doc(`users/${props.userId}`).update({
      player_ids: player_ids,
    });
  }, [props]);

  return (
    <>
      {contact_info && (
        <li className="idPlayer__el">
          <div className="idPlayer__img">
            <img
              src={require(`../../../../assets/img/${contact_info.vignette_url}`)}
              alt={contact_info.name}
            />
          </div>

          <div className="idPlayer__info">
            <span className="idPlayer__id">{props.idInfo.player_id}</span>
            <span className="idPlayer__launcher">{contact_info.name}</span>
          </div>
          {props.myProfil && (
            <Dropdown className="idPlayer__btnOpt  btn--options">
              <Dropdown.Toggle as="button">
                <span></span>
                <span></span>
                <span></span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as="button" onClick={() => deleteIdPlayer()}>
                  Supprimer
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </li>
      )}
    </>
  );
};

export default IdPlayer;
